import { combineTokens, makeSelectors } from '@utils/css';

const tokens = combineTokens("--dropzone", {
  offsetTop: "0px"
});
const contentWrapper = "_35sc19wuxjg";
const content = "_35sci27e2l";
makeSelectors({
  dropzone: content,
  content
});

export { content, contentWrapper, tokens };
import "./molecule.content.style.linaria.module.css";
//# sourceMappingURL=molecule.content.style.js.map
